import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CheckboxModule } from 'primeng/checkbox';
import { SelectModule } from 'primeng/select';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { ListboxModule } from 'primeng/listbox';
import { PcpCommandBarModule } from './../../../../../pcpcommandbar/pcp-commandbar.module';
import { ChangeOrderNotificationsComponent } from './changeorder.notifications.component';
import { CheckAccessDirective } from '../../../../../../directives';

@NgModule({
    imports: [
        CheckboxModule,
        CommonModule,
        SelectModule,
        FormsModule,
        ToggleSwitchModule,
        ListboxModule,
        PcpCommandBarModule,    
        ChangeOrderNotificationsComponent,
        CheckAccessDirective
    ],
    exports: [ChangeOrderNotificationsComponent]
})
export class ChangeOrderNotificationsModule { }
